import { PortCallVersion as ServerPortCallVersion } from 'server/models/PortCallVersion';
import { PortCallVersionExtraDataData } from './PortCallVersionExtraData';
import { parseIfNonNull } from './ExtraDataUtils';

export { PortCallVersionData, PortCallVersionOptions } from 'server/models/PortCallVersion';

export class PortCallVersion extends ServerPortCallVersion {
    ExtraData() {
        return parseIfNonNull<PortCallVersionExtraDataData>(this.ExtraDataJSON());
    }
}



// WEBPACK FOOTER //
// ./data/models/PortCallVersion.ts